import React from "react";
import styles from "./TasksCoachmark.module.scss";

type Props = {
  targetRef: React.RefObject<HTMLElement>;
  onClose: () => void;

  firstName: string;
  message: React.ReactNode;
};

const TasksCoachmark: React.FC<Props> = ({
  targetRef,
  onClose,
  firstName,
  message,
}) => {
  if (!targetRef.current) return null;

  const isMobile = globalThis.innerWidth <= 768;

  return (
    <div
      className={styles.container}
      style={
        isMobile
          ? {
              bottom: "100%",
              marginBottom: "1.2rem",
            }
          : {
              top: "50%",
              left: "100%",
              marginLeft: "1.2rem",
              transform: "translateY(-50%)",
            }
      }
    >
      <button
        className={styles.close}
        onClick={onClose}
        aria-label="Close"
      >
        ✕
      </button>

      <div className={styles.content}>
        <div className={styles.title}>
          Hi <span className={styles.name}>{firstName}</span>
        </div>

        <div className={`${styles.description} paragraph-medium-regular`}>
          {message}
        </div>
      </div>
    </div>
  );
};

export default TasksCoachmark;
